import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage } from '../redux/slices/languageSlice';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { useLocation } from 'react-router-dom';

const LanguageSwitcher = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const location = useLocation();
  const currentLanguage = useSelector(state => state.language.currentLanguage);
  const availableLanguages = useSelector(state => state.language.availableLanguages);
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // UserDashboard sayfasında ise gizle
  const isUserDashboard = location.pathname === '/user-dashboard';

  const handleChange = (lang) => {
    dispatch(changeLanguage(lang));
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  // Menü dışına tıklanınca kapansın
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  // UserDashboard'da gizle
  if (isUserDashboard) {
    return null;
  }

  // Diğer sayfalarda sağ altta göster (mevcut davranış)
  return (
    <div style={{position: 'fixed', right: 32, bottom: 32, zIndex: 9999}} ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          boxShadow: open ? '0 4px 16px rgba(25, 118, 210, 0.25)' : '0 2px 8px rgba(0,0,0,0.15)',
          fontSize: 28,
          cursor: 'pointer',
          outline: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'box-shadow 0.2s, background 0.2s',
        }}
        title="Dil Değiştir / Change Language"
      >
        <LanguageIcon style={{ fontSize: 32 }} />
      </button>
      {open && (
        <div style={{
          position: 'absolute',
          right: 0,
          bottom: 70,
          background: '#fff',
          border: '1.5px solid #1976d2',
          borderRadius: 12,
          boxShadow: '0 4px 16px rgba(25, 118, 210, 0.15)',
          padding: 8,
          minWidth: 140,
          animation: 'fadeIn 0.2s',
        }}>
          {availableLanguages.map(lang => (
            <div
              key={lang.code}
              onClick={() => handleChange(lang.code)}
              style={{
                padding: '10px 16px',
                cursor: 'pointer',
                background: currentLanguage === lang.code ? '#e3f2fd' : 'transparent',
                borderRadius: 8,
                fontWeight: currentLanguage === lang.code ? 'bold' : 'normal',
                fontSize: 17,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                transition: 'background 0.2s',
              }}
            >
              <span style={{fontSize: 22}}>{lang.flag}</span> {lang.name}
            </div>
          ))}
        </div>
      )}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default LanguageSwitcher; 